import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  activeChannels = environment.activeChannels;
  hostname: any = environment.hostName;
  selectedChannel: string;
  activeFilterClass: string = 'btn btn-default fiter-btn filter-active';
  inactiveFilterClass: string = 'btn btn-default fiter-btn';

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.displaySelected();
  }

  displaySelected(selected: string = 'bank') {
    if (selected !== 'bank') {
      this.selectedChannel = selected;
    } else {
      this.selectedChannel = 'bank';
    }
  }

  simulateInquiry(path) {
    const notInquiryPath = ['credit-card', 'direct-debit-bri', 'shopeepay', 'bni', 'direct-transfer-bca', 'rekening-bersama-bca', 'paylater-akulaku','paylater-kredivo','paylater-indodana', 'linkaja'];
    if (notInquiryPath.includes(path)) {
      this.router.navigate([path]);
    } else {
      this.router.navigate([path + NavigationConstant.INQUIRY]);
    }
  }

  simulateIndomaret() {
    window.location.href = environment.indomaretUrl;
  }

  simulateBni() {
    window.location.href = environment.bniUrl;
  }

}
